import { connect } from 'react-redux';
import { addFutureChanged, changeMetricSelection } from '../actions';
import MetricsSelection from '../components/MetricsSelection';
import { getMetricsSelectionPage } from '../selectors';

const mapStateToProps = state => getMetricsSelectionPage(state);

const mapDispatchToProps = dispatch => {
    return {
        onChange: (id, value) => dispatch(changeMetricSelection(id, value)),
        enableAddFuture: () => dispatch(addFutureChanged('selectedMetrics', false, true)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(MetricsSelection);
